import { render, staticRenderFns } from "./SalesOrderStatuses.vue?vue&type=template&id=93ad602e&"
import script from "./SalesOrderStatuses.vue?vue&type=script&lang=js&"
export * from "./SalesOrderStatuses.vue?vue&type=script&lang=js&"
import style0 from "./SalesOrderStatuses.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports